import { Command, CurdDataSetConfig, FormFieldConfig, FormFieldType, ResponseSimple } from '../types';
import { toDateFormat } from '@mri/functions';
import { SendCommandDialogComponent } from '@mri/app/modules';
import { forkJoin, tap } from 'rxjs';

const filterConfig: Array<FormFieldConfig> = [
  {
    key: 'mobileId',
    label: 'Vehiculo',
    type: FormFieldType.OPTIONS_MULTIPLE,
    optionsGateway: 'mobiles'
  },
  {
    key: 'deviceId',
    label: 'Dispositivo',
    type: FormFieldType.OPTIONS_MULTIPLE,
    optionsGateway: 'devices'
  },
  {
    key: 'propertyId',
    label: 'Propietario',
    type: FormFieldType.OPTIONS_MULTIPLE,
    optionsGateway: 'properties'
  }
]

export const commandDataSetConfig: CurdDataSetConfig<Command> = {
  entityName: 'Comandos',
  collectionName: 'Commands',
  gatewayUrl: 'commands',
  baseBreadcrumb: 'commands',
  list: {
    pageConfig: {
      title: 'Reporte de comandos',
      breadcrumb: [
        {
          title: 'Reportes',
          type: 'item',
        },
        {
          title: 'Comandos',
          type: 'item',
          link: '/reports/commands/list',
          pageName: 'Reporte de comandos'
        }
      ]
    },
    table: {
      hasSocket: true,
      columns: [
        {
          key: 'commandName', label: 'Comando',
          getValue: ({ element }) => element.choice?.label?.['es'] || element.choice?.label?.['default'] || element.commandKey
        },
        {
          key: 'mobile', label: 'Placa',
          getValue: ({ element }) => element.mobile?.name || 'No definido'
        },
        {
          key: 'status', label: 'estado',
          getValue: ({ element }) => {
            if (element.status === 'success')
              return '<span class="text-success-500"> Exitoso </span>';
            if (element.status === 'expired')
              return '<span class="text-warn-300"> Sin respuesta </span>';
            if (element.status === 'unsupported')
              return '<span class="text-warn-300"> No soportado </span>';

            return 'Pendiente';
          }
        },
        {
          key: 'senderFor', label: 'Enviado por',
          getValue: ({ element }) => {
            const { senderUser } = element;
            const { contact } = senderUser || {};

            if (!contact) return 'No definido';

            return `${contact.firstName} ${contact.lastName}`;
          }
        },
        {
          key: 'createdTime', label: 'Fecha de envio',
          getValue: ({ element }) => toDateFormat(element.createdTime)
        }
      ]
    },
    actionsKeys: [],
    filter: filterConfig,
    searchFilter: filterConfig,
    extraActions: [
      {
        key: 'send-command',
        label: 'Enviar',
        icon: 'fi fi-br-paper-plane',
        click: ({ component }) => {
          if (!component) return;

          const dialogSrv = component.dialogSrv;

          dialogSrv.open(SendCommandDialogComponent, {
            data: {
              submitted: () => component.reload()
            },
            autoFocus: false, disableClose: true
          });
        }
      },
      {
        key: 'send-command',
        label: 'Reenviar',
        icon: 'fi fi-br-paper-plane-launch',
        disableWhen: ({ selectedElements}) =>{
          if(!selectedElements?.length) return true;
          return !(selectedElements || []).reduce( (value, next) => value && next.status !== 'success', true)
        },
        click: ({ component, selectedElements }) => {
          const genericSrv = component?.genericResourceSrv;

          if(! genericSrv) return;

          return forkJoin(
            (selectedElements || [])?.map( element =>
              genericSrv.postElement<ResponseSimple<Command>>('commands', element)
            )
          ).pipe(
            tap( () => component?.reload())
          )
        }
      }
    ]
  },
  pages: ['list']
};
